import {useTaskStatuses} from '../hooks';

const withTaskStatuses = (Component) => {
  return (props) => {
    const statuses = useTaskStatuses();
    return <Component statuses={statuses} {...props}/>;
  }
};

export default withTaskStatuses;
